import {
    CircularProgress,
    MenuItem,
    TextFieldProps, TextField
} from "@mui/material";
import React, {useEffect} from "react";


export type LoadingSelectProps = Omit<TextFieldProps, "defaultValue"> & {
    loading?: boolean
    options?: {title: any, value: string}[]
    empty?: string | React.ReactElement
    onLoading?: (loading: boolean) => void
}


export const LoadingSelect = (props: LoadingSelectProps) => {
    let {disabled, loading, options, empty, value, onLoading, SelectProps, ...otherProps} = props;
    const Option = SelectProps?.native ? (props) => <option {...props}/> : MenuItem;
    const isEmpty = options?.length == 0 && !loading;

    useEffect(() => {
        onLoading && onLoading(loading);
    }, [Boolean(loading)])

    return (
        <TextField
            {...otherProps as TextFieldProps}
            select
            disabled={disabled}
            value={loading ? "" : value}
            defaultValue=""
        >
            {isEmpty && (
                <Option value="">
                    {empty || "Пусто"}
                </Option>
            )}
            {!loading && options?.map(option => (
                <Option value={option.value} key={option.value}>
                    {option.title}
                </Option>
            ))}
            {loading && (
                <Option value="">
                    Загрузка...
                </Option>
            )}
        </TextField>
    )
}